import React, { MouseEvent } from 'react';
import { ThemeProvider } from 'styled-components';
import BlockHeaderIcon from './BlockHeaderIcon/BlockHeaderIcon';
import { IconTypes } from '../../../helpers/constants';
import { BlockHeaderTitleWrapper, BlockHeaderWrapper } from './styles';
import Heading from '../../Typography/Heading/Heading';

export interface BlockHeaderProps {
  title?: string;
  isTransparent?: boolean;
  iconLeftType?: IconTypes;
  iconLeftTestId?: string;
  iconLeftCallback?: (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  iconRightType?: IconTypes;
  iconRightTestId?: string;
  iconRightCallback?: (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  'data-testid'?: string | number;
}

function BlockHeader(props: BlockHeaderProps) {
  const { title, iconLeftType, iconRightType, isTransparent, iconLeftCallback, iconRightCallback } = props;
  const { iconRightTestId, iconLeftTestId, 'data-testid': dataTestId, ...otherProps } = props;

  return (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        transparent: isTransparent,
      })}
    >
      <BlockHeaderWrapper data-testid={dataTestId}>
        {iconLeftType && (
          <BlockHeaderIcon
            {...otherProps}
            type={iconLeftType}
            callback={iconLeftCallback}
            left
            data-testid={iconLeftTestId}
          />
        )}
        <BlockHeaderTitleWrapper>
          <Heading variant="heading-3" trim>
            {title}
          </Heading>
        </BlockHeaderTitleWrapper>
        {iconRightType && (
          <BlockHeaderIcon
            {...otherProps}
            type={iconRightType}
            callback={iconRightCallback}
            data-testid={iconRightTestId}
          />
        )}
      </BlockHeaderWrapper>
    </ThemeProvider>
  );
}

export default BlockHeader;
